/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const ListGroupMembersResponse = zod.object({
  members: zod.array(
    zod.object({
      email: zod.string().nullable(),
      firstName: zod.string().nullable(),
      lastActiveAt: zod.iso
        .datetime({ offset: true })
        .nullable()
        .describe('ISO 8601 date-time string'),
      lastName: zod.string().nullable(),
      name: zod.string(),
      profileImage: zod.union([
        zod.object({
          large: zod.union([
            zod.object({
              contentUuid: zod.uuid().nullable().describe('UUID v4 identifier'),
              url: zod.string().nullable(),
            }),
            zod.null(),
            zod.null(),
          ]),
          medium: zod.union([
            zod.object({
              contentUuid: zod.uuid().nullable().describe('UUID v4 identifier'),
              url: zod.string().nullable(),
            }),
            zod.null(),
            zod.null(),
          ]),
          original: zod.union([
            zod.object({
              contentUuid: zod.uuid().nullable().describe('UUID v4 identifier'),
              url: zod.string().nullable(),
            }),
            zod.null(),
            zod.null(),
          ]),
          small: zod.union([
            zod.object({
              contentUuid: zod.uuid().nullable().describe('UUID v4 identifier'),
              url: zod.string().nullable(),
            }),
            zod.null(),
            zod.null(),
          ]),
          xsmall: zod.union([
            zod.object({
              contentUuid: zod.uuid().nullable().describe('UUID v4 identifier'),
              url: zod.string().nullable(),
            }),
            zod.null(),
            zod.null(),
          ]),
        }),
        zod.null(),
        zod.null(),
      ]),
      roles: zod.array(
        zod.object({
          name: zod.string(),
          roleUuid: zod.uuid(),
        }),
      ),
      userActorUuid: zod.uuid(),
    }),
  ),
  nextCursor: zod.string().nullable(),
  totalCount: zod.int(),
});

export type ListGroupMembersResponse = zod.input<typeof ListGroupMembersResponse>;
export type ListGroupMembersResponseOutput = zod.output<typeof ListGroupMembersResponse>;
